// @flow
import * as React from 'react'

type Props = {
  children: React.Node,
}

export default class SectionHeading extends React.Component<Props> {
  render = () => {
    return <div className="Section-heading">{this.props.children}</div>
  }
}
